import { useState, useEffect } from "react";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import {
  fetchSizeOptions,
  fetchSlocOptions,
  getSampleUploadFile,
  uploadStickerData,
} from "../model/PrintingModel";

const UploadLabelVM = () => {
  const { handleToastOpen } = useToast();
  const [sizeOptions, setSizeOptions] = useState([]);
  const [sLocOptions, setSLocOptions] = useState([]);
  const [selectedSizeId, setSelectedSizeId] = useState([]);
  const [selectedSLoc, setSelectedSLoc] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [alertModelOpen, setAlertModelOpen] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  useEffect(() => {
    const fetchSize = async () => {
      try {
        const response = await fetchSizeOptions();
        setSizeOptions(response.data);
      } catch (error) {
        handleToastOpen("error", error.message);
        setSizeOptions([]);
      }
    };
    const fetchSloc = async () => {
          try {
            const response = await fetchSlocOptions();
            setSLocOptions(response.data.options);
            if (response.data.length === 1) {
            }
          } catch (error) {
            handleToastOpen("error", error.message);
            setSLocOptions([]);
          }
        };
    fetchSize();
    fetchSloc()
  }, []);

  const handleSizeChange = (value) => {
    setSelectedSizeId(value.id);
  };
  const handleStorageLocationChange = (value) => {
    setSelectedSLoc(value);
    //changePrefeerence(value);
  };

 

  const handleSampleFileDownload = async () => {
    try {
      const response = await getSampleUploadFile("label");
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `SampleLabelUpload.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleToastOpen("success", "File Downloaded Successfully");
    } catch (error) {
      handleToastOpen("error", "File download Unsuccessful");
    }
  };

  const handleFileChoose = (files) => {
    setSelectedFiles(files);
  };

  const handleLabelFileUpload = async () => {
    setIsUploading(true);
     if(selectedSizeId.length===0){
      handleToastOpen("error","No size selected")
      setIsUploading(false)
    }
    else if(selectedSLoc==null || selectedSLoc===undefined){
      handleToastOpen("error","No storage location selected")
      setIsUploading(false)
    }
    else if(selectedFiles.length===0){
      handleToastOpen("error","No file selected")
      setIsUploading(false)
    }
    else {
    try {
      const response = await uploadStickerData(selectedSizeId, selectedFiles,selectedSLoc);
      // handleToastOpen("success", response.data.message);
      // if (response.data.message) {
      //   window.location.reload();
      // }
      // alert(response.data.message)
      setResponseMessage(response.data.message)
      setAlertModelOpen(true)
      // handleToastOpen("success", response.data.message);
      // if (response.data.message) {
      //   window.location.reload();
      // }
    } catch (error) {
      handleToastOpen("error", error.message);
      setIsUploading(false);
    }
  }
  };

  return {
    sizeOptions,
    sLocOptions,
    handleSizeChange,
    handleStorageLocationChange,
    handleSampleFileDownload,
    handleFileChoose,
    handleLabelFileUpload,
    isUploading,
    alertModelOpen,
    setAlertModelOpen,
    responseMessage,
  };
};

export default UploadLabelVM;